import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import { Checkbox as KendoCheckbox } from '@progress/kendo-react-inputs';
import classNames from 'classnames';
import WithTooltip from '../../../utility/withTooltip';
import PuzzleTooltip from '../tooltip/PuzzleTooltip';
import _ from 'lodash';
import { PUZZLE_CHECKBOX_PROPS } from './Types';
import { TOOLTIP_OMITTED_PROPS } from '../../../utility';

/**
 * This component serves as extended version of Kendo's checkbox
 * @author Stevan Stojanovic
 **/
class PuzzleCheckbox extends PureComponent<PUZZLE_CHECKBOX_PROPS> {
  tooltip: any = null;

  static defaultProps = {
    tooltipOpenDelay: 1000,
    tooltipAnchor: 'target'
  }

  render(): any {
    const {
      className = '',
      locked = false,
      value,
      appearance,
      withTooltip,
      titleText,
      tooltipContent,
      tooltipPosition,
      tooltipOpenDelay,
      tooltipAnchor,
      tooltipClassName = ''
    } = this.props;
    const dataCy = this.props['data-cy'] || 'checkbox';

    const checkboxClasses = classNames(
      `tp-checkbox ${className} k-d-inline-flex k-align-items-center`,
      {
        'qa-fakeClass-checked': value,
        'tp-checkbox-favorite': appearance === 'star',
        'tp-checkbox-lock': appearance === 'lock',
        'k-state-locked': locked
      }
    );

    const checkBoxOmittedProps = ['appearance'].concat(TOOLTIP_OMITTED_PROPS);
    const checkboxProps = _.omit(this.props, checkBoxOmittedProps);

    if (withTooltip) {
      return (
        <>
          <WithTooltip
            className={tooltipClassName}
            context={this}
            title={titleText}
            htmlTag={'span'}
          >
            <KendoCheckbox
              {...checkboxProps}
              // <debug>
              data-cy={dataCy}
              // </debug>
              className={checkboxClasses}
              title={titleText}
            />
          </WithTooltip>
          <PuzzleTooltip
            anchorElement={tooltipAnchor}
            ref={(el: any) => this.tooltip = el}
            openDelay={tooltipOpenDelay}
            position={tooltipPosition}
            content={tooltipContent}
          />
        </>
      );
    }

    return (
      <KendoCheckbox
        {...checkboxProps}
        tabIndex={locked ? -1 : 0}
        className={checkboxClasses}
      />
    );
  }
}

export default PuzzleCheckbox;
